module Client.Model

open Client.Domain
open Client.Domain.Navbar
open Client.DomainTypes
open Client.DomainTypes.Msg
open Client.Infrastructure.Api
open Client.Page
open Client.Page.Admin
open Client.Page.User
open Client.Session
open Elmish
open Shared.Dto.Dto

type PageModel =
    | Login of Login.Model
    | Home of Home.Model
    | MyProfile of MyProfile.Model
    | PublicPage of PublicMap.Model
    | SensorPage of SensorMap.Model
    | PendingSession of PendingSession.Model
    | TtnSensorList of PhysicalSensorList.Model
    | MySensSensorList of Loadable<MapSensorList.DataModel, MapSensorList.LoadingModel>
    | GatewayList of Loadable<GatewayList.DataModel, GatewayList.LoadingModel>
    | UserList of UserList.Model
    | CalculationConfiguration of CalculationConfiguration.Model
    | NotFound
    | NotAllowed
    | PasswordLost of PasswordLost.Model
    | ResetPassword of ResetPassword.Model
    | MapSensorData of MapSensorDataPage.Model
    | AlertsList of AlertsList.Model
    | MyAlerts of MyAlerts.Model
    | MySensorsData of MySensorsData.Model
    | UserDefinedMapSensorSettings of UserDefinedMapSensorProperties.Model
    | MyMapSensors of MyMapSensors.Model
    | RimPro of RimPro.Model
    | MyGateways of MyGateways.Model
    | ScabData of ScabData.Model
    | MyScabStations of MyScabStations.Model
    | MyUserGroups of MyUserGroups.Model
    | MyPeronosporaStations of MyPeronosporaStations.Model
    | PeronosporaData of PeronosporaData.Model
    | GroupList of GroupList.Model
    | MyTalgilTriggers of MyTalgilTriggers.Model
    | MyTipBurnStations of MyTipburnStations.Model
    | TipBurnData of TipBurnData.Model
    | ReceivedSensorPackets of ReceivedSensorPackets.Model
    | TalgilTriggerExecutionLog of TalgilTriggerExecutionLog.Model

type Model = {
    Session: ClientSession
    NavbarModel: NavbarModel
    Page: PageModel
}

let initialModel (initialRoute: Option<Route>) : Model * Cmd<Msg> =
    let route = initialRoute |> Option.defaultValue Route.Home

    let sessionCmd =
        Cmd.OfAsync.either
            api.getSession
            (loadClientSessionId () |> Option.map SessionKey)
            SessionReceived
            LoadingSessionFailed
        |> Cmd.map Global

    {
        Session = ClientSession.Pending
        NavbarModel = Navbar.initialNavbarModel
        Page = PageModel.PendingSession(PendingSession.init route)
    },
    sessionCmd

let reinitModel (route: Route) (additionalCommand: Cmd<Msg>) : Model * Cmd<Msg> =
    let sessionCmd =
        Cmd.OfAsync.either
            api.getSession
            (loadClientSessionId () |> Option.map SessionKey)
            SessionReceived
            LoadingSessionFailed
        |> Cmd.map Global

    let navCmd = route |> Routing.routeToUrl |> Navigation.Navigation.newUrl

    {
        Session = ClientSession.Pending
        NavbarModel = Navbar.initialNavbarModel
        Page = PageModel.PendingSession(PendingSession.init route)
    },
    Cmd.batch [ sessionCmd; additionalCommand; navCmd ]